/* eslint-disable no-console */

'use client';

import { memo, useState } from 'react';

import { useAuth } from '@/core/auth/client/AuthProvider';
import { NavBarAuthenticated } from '@/features/v2/common/navbar/NavBarAuthenticated';
import WrapperNavbar from '@/features/v2/shared/Header/navbars/WrapperNavbar';
import { useMountEffect } from '@/hooks/useMountEffect';

import NavigationBarSkeleton from '@/components/ui/skeletonMobilebar';
import NavBarSkeleton from '@/components/ui/skeletonNavbar';

const NavigationStructure = () => {
  const { loading } = useAuth();
  const [isHydrated, setIsHydrated] = useState(false);

  useMountEffect(() => {
    setIsHydrated(true);
  });

  if (!isHydrated || loading) {
    return (
      <>
        <div className="w-full fixed z-50">
          <NavBarSkeleton />
        </div>
        <NavigationBarSkeleton />
      </>
    );
  }

  return (
    <>
      <div className="w-full fixed z-50">
        <WrapperNavbar />
      </div>
      <NavBarAuthenticated />
    </>
  );
};

export default memo(NavigationStructure);
